import { matchRoutes } from 'react-router-dom'

export const isRouteActive = (location: any, pattern: string): boolean => {
  const route = matchRoutes([{ path: pattern }], location)
  return route != null && route.length > 0
}

/**
 * OP-3605 — Um link do header pode declarar `exclude`: rota que casa com o
 * padrão mas pertence a outro link. A entrada de OS usa `interno/*` (cobre
 * /interno/os, /interno/tecnicos, /interno/config, /interno/analytics) e
 * exclui `interno/estoque/*`, que é do link de Estoque.
 */
export const isNavLinkActive = (location: any, link: { pattern: string; exclude?: string }): boolean =>
  isRouteActive(location, link.pattern) && !(link.exclude ? isRouteActive(location, link.exclude) : false)
